import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Image from "./ImageModal/Image";
import QuestionModal from "./QuestionModal/QuestionModal";
import JsonViewer from "./SdkData/JsonViewer";
import { useSelector } from "react-redux";
import MobileView from "./MobileView/MobileView";
import AuditLogs from "./AuditLogs/auditLogs";
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function RightSideTabs({
  data,
  project,
  setWidth,
  setTop,
  mobileWidth,
}) {
  const [value, setValue] = React.useState(0);
  const { optixData, sdkData, mobileData, imageData } = useSelector(
    (state) => state.imageViewerStore
  );
  const { logData } = useSelector((state) => state.imageViewerStore);
  const { selectedAudit } = useSelector((state) => state.imageVCStore);
  // console.log("zzzzzzzzzzzzz", logData.auditLogs.length);
  console.log("pppppppppppppppp", selectedAudit);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  // const auditID = event.currentTarget.textContent;

  return (
    <Box
      sx={{
        position: "absolute",
        top: setTop ? `${setTop}` : "3rem",
        width: setWidth ? `${setWidth}` : "80%",

        // marginLeft: "auto",
        // marginLeft:"-94px",
        // paddingLeft: "16px",

        // right: "60px",
        right: 0,
      }}
    >
      <Box
        sx={{
          borderColor: "divider",
          paddingLeft: "9.6rem",
          justifyContent: "center",
          alignItems: "center  ",
          // backgroundColor:"pink",
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab
            label="Images"
            {...a11yProps(0)}
            style={{ fontFamily: "ChalkboardSE-Regular", fontWeight: "bold" }}
          />
          <Tab
            label="Ques & Ans"
            {...a11yProps(1)}
            style={{ fontFamily: "ChalkboardSE-Regular", fontWeight: "bold" }}
          />
          {/* <Tab
            label="SDK Results"
            {...a11yProps(2)}
            style={{ fontFamily: "ChalkboardSE-Regular", fontWeight: "bold" }}
          />
          <Tab
            label="Audit logs"
            {...a11yProps(3)}
            style={{ fontFamily: "ChalkboardSE-Regular", fontWeight: "bold" }}
          />
          {project === "india-live" && (
            <Tab
              label="Mobile View Result"
              {...a11yProps(4)}
              style={{ fontFamily: "ChalkboardSE-Regular", fontWeight: "bold" }}
            />
          )} */}
          {/* <Tab label="Optix Results" {...a11yProps(4)} /> */}
        </Tabs>
      </Box>

      <CustomTabPanel
        value={value}
        index={0}
        // style={{
        //   marginRight: "34px",
        //   overflow: "auto",
        //   //  scrollbarWidth: '8px',
        //   // backgroundColor:"pink",

        //   // scrollbarColor: 'blue',
        // }}
      >
        {imageData.length === 0 && (
          <div style={{ fontSize: "11px" }}>No data</div>
        )}
        {imageData.length !== 0 && <Image data={data} />}
      </CustomTabPanel>

      <CustomTabPanel value={value} index={1}>
        {imageData.length === 0 && (
          <div style={{ fontSize: "11px" }}>No data</div>
        )}
        {imageData.length !== 0 && <QuestionModal data={data} />}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        {sdkData && sdkData.length === 0 && (
          <div style={{ fontSize: "11px" }}>No data</div>
        )}
        {sdkData && sdkData.length !== 0 && <JsonViewer data={sdkData} />}
      </CustomTabPanel>
      {/* <CustomTabPanel value={value} index={3}>
        {logData.auditLogs.length === 0 && (
          <div style={{ fontSize: "11px" }}>No data</div>
        )}
        {logData.length !== 0 && <AuditLogs data={logData} />}
      </CustomTabPanel> */}
      <CustomTabPanel value={value} index={3}>
        {logData?.auditLogs?.length === 0 ? (
          <h3 style={{ marginLeft: "165px" }}>No data</h3>
        ) : (
          // <AuditLogs data={logData} selectedAudit={selectedAudit}/>
          <AuditLogs data={logData} />
        )}
      </CustomTabPanel>
      {project === "india-live" && (
        <CustomTabPanel value={value} index={4}>
          {mobileData.length === 0 && (
            <div style={{ fontSize: "11px" }}>No data</div>
          )}
          {mobileData.length !== 0 && (
            <MobileView data={mobileData} mobileWidth={mobileWidth} />
          )}
        </CustomTabPanel>
      )}

      {/* <CustomTabPanel value={value} index={4}>
        {optixData.length !== 0 && <JsonViewer data={optixData} />}
      </CustomTabPanel> */}
    </Box>
  );
}
